import React, { reactCSS, Component } from 'react';
import { SwatchesPicker, SketchPicker, ChromePicker } from 'react-color';

class TopbarProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      topbarContent: "",
      topbarBtnText: "",
      topbarBtnUrl: "",

      contentDisplayColorPicker: false,
      topbarBackgroundDisplayColorPicker: false,
      btnBackgroundDisplayColorPicker: false,
      btnColorDisplayColorPicker: false,

      contentColor: "#000",
      btnColorColor: "#FFF",
      btnBackgroundColor: "#000",
      topbarBackgroundColor: "#FFF"
    }

    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
  }

  handleClick = (e) => {
    if ( !e.target.getAttribute('data-picker') ) return

    let propName = e.target.getAttribute('data-picker')+'DisplayColorPicker'
    this.setState({ [propName]: !this.state[propName] })
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value}, () => {
      let obj = {
        topbarContent: this.state.topbarContent,
        topbarBtnText: this.state.topbarBtnText,
        topbarBtnUrl: this.state.topbarBtnUrl,
        topbarContentColor: this.state.contentColor,
        topbarBtnColor: this.state.btnColorColor,
        topbarBtnBackground: this.state.btnBackgroundColor,
        topbarBackgroundColor: this.state.topbarBackgroundColor
      }

      this.props.handleWebviewProps(obj, true);
    });
  }

  handleColorChange = (color, elem) => {
    let propName = elem+'Color';
    this.setState({ [propName]: color.hex }, () => {
      let obj = {
        topbarContent: this.state.topbarContent,
        topbarBtnText: this.state.topbarBtnText,
        topbarBtnUrl: this.state.topbarBtnUrl,
        topbarContentColor: this.state.contentColor,
        topbarBtnColor: this.state.btnColorColor,
        topbarBtnBackground: this.state.btnBackgroundColor,
        topbarBackgroundColor: this.state.topbarBackgroundColor
      }

      this.props.handleWebviewProps(obj, true);
    })
  }

  handleSubmit = (e) => {
    if ( this.state.topbarContent.length === 0 || this.state.topbarContent.length === 0 || this.state.topbarBtnText.length === 0 ) return;

    let obj = {
      topbarContent: this.state.topbarContent,
      topbarBtnText: this.state.topbarBtnText,
      topbarBtnUrl: this.state.topbarBtnUrl,
      topbarContentColor: this.state.contentColor,
      topbarBtnColor: this.state.btnColorColor,
      topbarBtnBackground: this.state.btnBackgroundColor,
      topbarBackgroundColor: this.state.topbarBackgroundColor
    }

    this.props.handleWebviewProps(obj, false);
  }

  render() {
    return(
      <div className="webview-component-group">
        <div className="webview-data-group">
          <p className="group-title">Conteúdo:</p>
          <div className="row">
            <div className="col-12">
              <div className="input-wrapper">
                <label htmlFor="topbarContent">Qual o conteúdo da barra de topo? <strong>(Obrigatório)</strong></label>
                <textarea name="topbarContent" id="topbarContent" className="form-control" onChange={this.handleChange} defaultValue={this.state.topbarContent}></textarea>
              </div>
            </div>
            <div className="col-6">
              <div className="input-wrapper">
                <label htmlFor="topbarBtnText">Qual será o texto do CTA? <strong>(Obrigatório)</strong></label>
                <input type="text" name="topbarBtnText" id="topbarBtnText" className="form-control" onChange={this.handleChange} defaultValue={this.state.topbarBtnText}/>
              </div>
            </div>
            <div className="col-6">
              <div className="input-wrapper">
                <label htmlFor="topbarBtnUrl">Qual será o link do CTA?</label>
                <input type="url" name="topbarBtnUrl" id="topbarBtnUrl" className="form-control" onChange={this.handleChange} defaultValue={this.state.topbarBtnUrl}/>
              </div>
            </div>
          </div>

          <div className="webview-data-group">
            <p className="group-title">Estilo:</p>
            <div className="row">
              <div className="col-4">
                <div className="input-wrapper">
                  <label className="no-margin">Qual a cor de fundo da barra?</label>
                  {
                    this.state.topbarBackgroundDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.topbarBackgroundColor } onChange={ (color) => { this.handleColorChange(color, 'topbarBackground') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="topbarBackground"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="topbarBackground" style={{width: "76px", height: "38px", backgroundColor: this.state.topbarBackgroundColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>

              <div className="col-4">
                <div className="input-wrapper">
                  <label className="no-margin">Qual a cor do conteúdo?</label>
                  {
                    this.state.contentDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.contentColor } onChange={ (color) => { this.handleColorChange(color, 'content') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="content"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="content" style={{width: "76px", height: "38px", backgroundColor: this.state.contentColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>

              <div className="col-4">
                <div className="input-wrapper">
                  <label>Qual a cor de fundo do CTA?</label>
                  {
                    this.state.btnBackgroundDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.btnBackgroundColor } onChange={ (color) => { this.handleColorChange(color, 'btnBackground') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="btnBackground"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="btnBackground" style={{width: "76px", height: "38px", backgroundColor: this.state.btnBackgroundColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>
            </div>
            
            <div className="row">
              <div className="col-4">
                <div className="input-wrapper">
                  <label>Qual a cor do texto do CTA?</label>
                  {
                    this.state.btnColorDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.btnColorColor } onChange={ (color) => { this.handleColorChange(color, 'btnColor') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="btnColor"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="btnColor" style={{width: "76px", height: "38px", backgroundColor: this.state.btnColorColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" className="btn btn-blue" style={{marginTop: "60px"}} onClick={this.handleSubmit}>Salvar</button>
      </div>
    )
  }
}

export { TopbarProperties as Topbar }